import React, { useContext, useState, useRef } from 'react';
import { useMutation } from '@apollo/client';
import SignatureCanvas from 'react-signature-canvas';
import { UPDATE_DEFAULT_TITLE_RELEASE } from './queries';
import AuthContext from 'src/contexts/AuthContext';

export default function DefaultTitleRelease() {
  const [form, setForm] = useState({
    titleOwnerName: '',
    titleShippingAddress1: '',
    titleShippingAddress2: '',
    titleCity: '',
    titleState: '',
    titleZip: '',
    titleShipOwnerName: '',
    titleShipShippingAddress1: '',
    titleShipShippingAddress2: '',
    titleShipCity: '',
    titleShipState: '',
    titleShipZip: '',
    defaultTitleReleaseSignature: '',
  });

  const {
    currentUser,
    isLoggedIn,
    refetchCurrentUser,
    checkedCredentials,
  } = useContext(AuthContext);

  console.log("Logged In?", isLoggedIn);

  const sigCanvas = useRef();
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [updateDefaultTitleRelease, { data, loading, error }] = useMutation(
    UPDATE_DEFAULT_TITLE_RELEASE
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleClearSignature = () => {
    sigCanvas.current?.clear();
    setForm({ ...form, defaultTitleReleaseSignature: '' });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const signatureData = sigCanvas.current?.isEmpty()
      ? ''
      : sigCanvas.current?.toDataURL();

    updateDefaultTitleRelease({
      variables: {
        ...form,
        defaultTitleReleaseSignature: signatureData,
      },
    }).then((result) => {
      if (
        !result.errors &&
        !result.data?.updateDefaultTitleRelease?.errors?.length
      ) {
        setIsSubmitted(true);
      }
    });
  };

  const ThankYou = () => (
    <div style={{
      maxWidth: 600,
      margin: '0 auto',
      padding: 20,
      textAlign: 'center',
      border: '1px solid #ccc',
      borderRadius: '8px',
      backgroundColor: '#f9f9f9'
    }}>
      <h2>Thank You!</h2>
      <p style={{ marginBottom: '30px' }}>
        We have received your Default Title Release Information. We will process this shortly.
      </p>
      <a
        href="/account/profile"
        style={{
          display: 'inline-block',
          padding: '10px 20px',
          backgroundColor: '#c00',
          color: '#fff',
          textDecoration: 'none',
          borderRadius: '4px'
        }}
      >
        Return Home
      </a>
    </div>
  );

  if (isLoggedIn === false) {
    return (
      <div style={{width: "100%", padding: "10px"}}>
        You must be logged in to view this page.  <a href="/login">Click Here to Login</a>, and then click on the link in your email to return to this page to update your default title release information.
      </div>
    )
  }

  return (
    <div style={{ maxWidth: 960, margin: '0 auto', padding: 20 }}>
      {isSubmitted ? (
        <ThankYou />
      ) : (
        <>
          <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>
            Default Title Release Information
          </h2>

          <form onSubmit={handleSubmit}>
            {/* Two Columns */}
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '20px',
              marginBottom: '30px',
            }}>
              {/* Column: Title Info */}
              <div style={{
                flex: 1,
                minWidth: 300,
                backgroundColor: '#f9f9f9',
                border: '1px solid #ccc',
                borderRadius: 8,
                padding: 16,
              }}>
                <h4 style={{ marginBottom: 16 }}>Information on Title / Información en el Título</h4>

                {[
                  { label: 'Name on title / Nombre en el título', name: 'titleOwnerName' },
                  { label: 'Address on title / Dirección en el título', name: 'titleShippingAddress1' },
                  { label: '(optional)', name: 'titleShippingAddress2', placeholder: '(optional)' },
                  { label: 'City / Ciudad', name: 'titleCity' },
                  { label: 'State / Estado', name: 'titleState' },
                  { label: 'Zip / Código Postal', name: 'titleZip' },
                ].map(({ label, name, placeholder }) => (
                  <div key={name} style={{ marginBottom: 12 }}>
                    <label style={{ display: 'block', marginBottom: 4 }}>{label}</label>
                    <input
                      type="text"
                      name={name}
                      value={form[name]}
                      onChange={handleChange}
                      placeholder={placeholder}
                      style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
                    />
                  </div>
                ))}
              </div>

              {/* Column: Shipping Info */}
              <div style={{
                flex: 1,
                minWidth: 300,
                backgroundColor: '#f9f9f9',
                border: '1px solid #ccc',
                borderRadius: 8,
                padding: 16,
              }}>
                <h4 style={{ marginBottom: 16 }}>Where to Ship Title / Dónde Enviar el Título</h4>

                {[
                  { label: 'Name to ship title to / Nombre a quien se enviará el título', name: 'titleShipOwnerName' },
                  { label: 'Address to ship title / Dirección a quien se enviará el título', name: 'titleShipShippingAddress1' },
                  { label: '(optional)', name: 'titleShipShippingAddress2', placeholder: '(optional)' },
                  { label: 'City / Ciudad', name: 'titleShipCity' },
                  { label: 'State / Estado', name: 'titleShipState' },
                  { label: 'Zip / Código Postal', name: 'titleShipZip' },
                ].map(({ label, name, placeholder }) => (
                  <div key={name} style={{ marginBottom: 12 }}>
                    <label style={{ display: 'block', marginBottom: 4 }}>{label}</label>
                    <input
                      type="text"
                      name={name}
                      value={form[name]}
                      onChange={handleChange}
                      placeholder={placeholder}
                      style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
                    />
                  </div>
                ))}

                <div style={{ fontSize: 12, fontStyle: 'italic', color: '#444' }}>
                  MUST BE A UNITED STATES ADDRESS and CAN NOT BE A PO BOX /
                  DEBE SER UNA DIRECCIÓN EN ESTADOS UNIDOS Y NO PUEDE SER UN APARTADO POSTAL
                </div>
              </div>
            </div>

            {/* Signature Section */}
            <div style={{
              border: '2px solid black',
              backgroundColor: '#f8f8f8',
              padding: '10px',
              borderRadius: '4px',
              marginBottom: '30px'
            }}>
              <label style={{ display: 'block', fontWeight: 'bold', marginBottom: 4 }}>Digital Signature</label>
              <p style={{ margin: 0, fontStyle: 'italic', color: '#555' }}>Please sign below</p>
              <SignatureCanvas
                penColor="black"
                canvasProps={{
                  width: 800,
                  height: 200,
                  className: 'sigCanvas',
                  style: {
                    border: '1px solid #ccc',
                    backgroundColor: '#fff',
                    borderRadius: '4px',
                    width: '100%',
                  },
                }}
                ref={sigCanvas}
              />
              <button type="button" onClick={handleClearSignature} style={{ marginTop: '10px' }}>
                Clear Signature
              </button>
            </div>

            {/* Submit */}
            <div style={{ textAlign: 'center' }}>
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: '12px 24px',
                  backgroundColor: '#c00',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: 16,
                  cursor: 'pointer',
                }}
              >
                {loading
                  ? 'Saving... / Guardando...'
                  : 'Save Default Title Release / Guardar Liberación de Título Predeterminada'}
              </button>
            </div>

            {/* Errors */}
            {error && (
              <p style={{ color: 'red', textAlign: 'center', marginTop: '20px' }}>
                Error: {error.message}
              </p>
            )}

            {data?.updateDefaultTitleRelease?.errors?.length > 0 && (
              <div style={{ color: 'red', textAlign: 'center', marginTop: '20px' }}>
                {data.updateDefaultTitleRelease.errors.map((err, idx) => (
                  <div key={idx}>{err.message}</div>
                ))}
              </div>
            )}
          </form>
        </>
      )}
    </div>
  );
}
